import { heroCover, heroTags } from "../../../mocks/clueSite";

export default function Hero() {
  return (
    <section id="top" className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-10 items-stretch">
          {/* 左：报头 + 头条 */}
          <div className="lg:col-span-7 flex flex-col justify-center order-2 lg:order-1">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                <i className="ri-vip-diamond-fill text-sm" />
                头版 · 今日头条
              </span>
              <span className="text-xs tracking-[0.25em] text-background-300/80">51 黑 料 原 创</span>
            </div>

            <h1 className="mt-4 md:mt-6 font-heading text-3xl md:text-5xl xl:text-[56px] font-black leading-[1.15] text-background-50">
              一份可以投稿的
              <br className="hidden md:block" />
              <span className="text-accent-400">「暗流密报」</span>清单
            </h1>

            <p className="mt-4 md:mt-5 max-w-xl text-sm md:text-base leading-relaxed text-background-200/85">
              51黑料持续汇总各方线人爆料与独家线索。只要你有内部消息、一手截图或行业"潜规则"，
              点下方入口提交，编辑组交叉核验后打码上线，你的信息就是下一条头条。
            </p>

            <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-400 whitespace-nowrap"
              >
                <i className="ri-upload-cloud-2-line text-base" />
                提供线索 / 投稿爆料
              </a>
              <a
                href="#feed"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-background-200/40 px-6 py-3 text-sm font-medium text-background-100 hover:bg-background-100/10 whitespace-nowrap"
              >
                <i className="ri-eye-line text-base" />
                先看最新线报
              </a>
            </div>

            <div className="mt-7 md:mt-9 flex flex-wrap items-center gap-2">
              {heroTags.map((t) => (
                <span
                  key={t.label}
                  className="tag-pill inline-flex items-center gap-1.5 rounded-full border border-background-200/25 bg-background-100/5 px-3 py-1.5 text-xs text-background-100 hover:border-accent-400 hover:text-accent-300"
                >
                  <i className="ri-hashtag text-accent-400" />
                  {t.label}
                  <span className="font-number font-bold text-accent-400">{t.count}</span>
                </span>
              ))}
            </div>
          </div>

          {/* 右：封面 */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative overflow-hidden rounded-lg">
              <div className="aspect-[3/4] w-full overflow-hidden">
                <img
                  src={heroCover}
                  alt="51黑料 暗流密报 封面专题"
                  title="51黑料 封面线报"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/5 to-transparent" />
              <div className="absolute left-3 bottom-3 right-3 md:left-4 md:bottom-4 md:right-4">
                <div className="flex items-center justify-between rounded-md bg-background-50 px-3 py-2.5 md:px-4 md:py-3">
                  <div>
                    <p className="text-[11px] text-foreground-500">本期封面线索热度</p>
                    <p className="font-heading text-lg md:text-xl font-black text-foreground-950">
                      98,241 <span className="text-primary-600">围观</span>
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-number text-2xl md:text-3xl font-extrabold text-accent-500">+32%</p>
                    <p className="text-[11px] text-foreground-500">较昨日</p>
                  </div>
                </div>
              </div>
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
                <i className="ri-live-fill" />
                正在发酵
              </span>
            </div>
          </div>
        </div>

        {/* 下缘入口条 */}
        <div className="mt-8 md:mt-10 rounded-md border border-background-200/20 bg-background-100/5 px-4 py-3 flex flex-col md:flex-row md:items-center gap-3">
          <div className="flex items-center gap-2 text-xs text-background-300/80 whitespace-nowrap">
            <i className="ri-megaphone-fill text-accent-400" />
            <span className="text-accent-300 font-medium">投稿须知</span>
          </div>
          <p className="flex-1 text-xs md:text-sm text-background-200/80">
            请勿投稿失实或涉个人隐私内容；被采纳线索将打码上线并回执采纳结果。匿名密报通道端到端加密，不记录设备指纹。
          </p>
          <a
            href="#guide"
            className="flex-none inline-flex items-center justify-center gap-1 rounded-full bg-primary-600 px-4 py-1.5 text-xs text-background-50 hover:bg-primary-500 whitespace-nowrap"
          >
            成为线人
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}